module.exports = __webpack_public_path__ + "static/media/MLQRLogo.svg";